import { ReactNode } from 'react';

import {
  Card,
  mergeSx,
  SxProps,
  InfoTooltip,
  Typography,
  Stack,
} from '@cast/design-system';

type Props = {
  title: string;
  titleInfo?: string;
  metrics?: ReactNode;
  sx?: SxProps;
  testId?: string;
};

export const MetricsCard = (props: Props) => {
  return (
    <Card
      data-testid={props.testId}
      className="tour-highlight"
      sx={mergeSx(
        {
          p: 16,
        },
        props.sx
      )}
    >
      <Stack gap={8}>
        <Stack direction="row" gap={4} alignItems="center">
          <Typography variant="L12R" noWrap={true}>
            {props.title}
          </Typography>
          {props.titleInfo && (
            <InfoTooltip title={props.titleInfo} placement="top" />
          )}
        </Stack>
        {props.metrics}
      </Stack>
    </Card>
  );
};
